import { render, staticRenderFns } from "./smallImg.vue?vue&type=template&id=019f524d&"
import script from "./smallImg.vue?vue&type=script&lang=js&"
export * from "./smallImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports